import * as React from 'react';
export const IcAttachment = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M22 9.17a6.09 6.09 0 00-10.39-4.31.413.413 0 00-.07.11 1.06 1.06 0 00-.11.07l-8.09 8.09a4.56 4.56 0 106.45 6.45l5.39-5.39a3.034 3.034 0 00-4.29-4.29L8 12.78a1 1 0 000 1.41.998.998 0 00.71.29 1 1 0 00.71-.29l2.87-2.88a1.04 1.04 0 111.47 1.47l-5.39 5.39a2.62 2.62 0 01-3.62 0 2.56 2.56 0 010-3.62l8.09-8.09.07-.11c.031-.022.062-.045.09-.07a4.09 4.09 0 115.78 5.78 1.06 1.06 0 00-.07.11s-.08 0-.11.07l-6.83 6.83a1 1 0 000 1.41 1 1 0 001.41 0L20 13.65c.026-.035.05-.072.07-.11 0 0 .08 0 .11-.07A6 6 0 0022 9.17z'
      fill='currentColor'
    />
  </svg>
);
